var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30 31.1429C30 30.6714 29.6271 30.2857 29.1667 30.2857H10.8333C10.3727 30.2857 10 30.6691 10 31.1429C10 31.6166 10.3727 32 10.8333 32H29.1667C29.6271 32 30 31.6143 30 31.1429ZM23.3333 25.3143V19.1429H26.375C27.1562 19.1429 27.8609 18.6658 28.1734 17.9241C28.4828 17.1875 28.3365 16.3304 27.8073 15.7518L21.4219 8.61607C21.0677 8.22436 20.5469 8 20 8C19.4531 8 18.9339 8.22436 18.5677 8.62464L12.2031 15.7443C11.6646 16.3293 11.5177 17.1859 11.8271 17.9284C12.1406 18.6661 12.8438 19.1429 13.625 19.1429H16.6667V25.3143C16.6667 26.6375 17.7135 27.7143 19 27.7143H21C22.2865 27.7143 23.3333 26.6375 23.3333 25.3143ZM19 26C18.6302 26 18.3333 25.6946 18.3333 25.3143V17.4286H13.6245C13.5089 17.4286 13.4031 17.3566 13.3559 17.2478C13.3125 17.1339 13.3333 17.0107 13.4219 16.9143L19.7865 9.79464C19.8802 9.69607 20.1302 9.70411 20.2031 9.78446L26.5833 16.9202C26.6667 17.0107 26.6875 17.1339 26.6458 17.2464C26.599 17.3589 26.4896 17.4286 26.375 17.4286H21.6667V25.3143C21.6667 25.6946 21.3646 26 21 26H19Z",
    fill: "#FF3E3A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.23976cfe49341c6e5d9056ad5b7deb1a.svg";
export { ForwardRef as ReactComponent };